import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

export function useScreenSize() {
  const theme = useTheme();
  const isExtraSmallDown = useMediaQuery(theme.breakpoints.down('xs'));
  const isSmallDown = useMediaQuery(theme.breakpoints.down('sm'));
  const isMediumDown = useMediaQuery(theme.breakpoints.down('md'));
  const isMediumUp = useMediaQuery(theme.breakpoints.up('md'));
  const isLargeUp = useMediaQuery(theme.breakpoints.up('lg'));
  const extraSmallDown = theme.breakpoints.down('xs');
  const smallDown = theme.breakpoints.down('sm');

  return { isExtraSmallDown, isSmallDown, isMediumDown, isMediumUp, isLargeUp, extraSmallDown, smallDown };
}
